import { atom } from "recoil";


const salesIdAtom = atom({
    key: 'currentSalesID',
    default: "",
});
  
export default salesIdAtom